import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchCaseTime = (companyId) => {
  return useQuery(
    ["getCaseTime", companyId],
    async () => {
      try {
        const endpoint = `/api/v1/companies/case-time/${companyId}`;
        const { result } = await GET(endpoint);
        return result.caseTime;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Case Time..");
        return null;
      }
    },
    {
      enabled: !!companyId,
    }
  );
};

export const useUpdateCaseTime = () => {
  return useMutation(
    async ({ companyId, deposit, withdraw, etc }) => {
      try {
        const endpoint = `/api/v1/companies/case-time`;
        const { result } = await PUT(endpoint, { companyId, deposit, withdraw, etc });
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Update Case Time..");
        throw error;
      }
    }
  );
}; 